// Central legal + business config. Update these values and every legal page
// (Terms, Privacy, Refund) + Contact + Footer will reflect the change.
export const LEGAL = {
  // Public-facing business name (what appears everywhere except Privacy Policy)
  companyLegalName: "Guest Smell",
  dba: "Guest Smell",
  brandMark: "Guest Smell™",
  founderName: "Chalounda Williams",

  // Address kept private: shown ONLY in Privacy Policy (legally required for
  // GDPR/CCPA data-controller identification) — never in Footer or Contact.
  address: {
    street: "[private — provided to Stripe & upon request]",
    city: "",
    state: "Texas",
    zip: "",
    country: "United States",
  },
  // Set to true to hide the address block from Footer + Contact page.
  hideAddressFromPublicPages: true,

  contactEmail: "chaloundaw@gmail.com",
  supportEmail: "chaloundaw@gmail.com",
  legalEmail: "chaloundaw@gmail.com",

  jurisdiction: "State of Texas, United States",
  governingLaw: "the laws of the State of Texas, without regard to conflict-of-law principles",

  effectiveDate: "February 24, 2026",
  lastUpdated: "February 24, 2026",

  // Pricing catalog — mirrored from Stripe lookup keys
  pricing: [
    { name: "Standard Certification", price: "$49",   type: "one-time"     },
    { name: "Premium Certification",  price: "$129",  type: "one-time"     },
    { name: "Standard → Premium upgrade", price: "$80", type: "one-time"   },
    { name: "Monthly Monitoring",     price: "$29/mo",  type: "subscription" },
    { name: "Yearly Monitoring",      price: "$290/yr", type: "subscription" },
  ],
};

export function formatAddress() {
  const a = LEGAL.address;
  const line1 = a.street;
  const line2 = [a.city, a.state, a.zip].filter(Boolean).join(a.city && a.state ? ", " : " ").trim();
  const line3 = a.country;
  return [line1, line2, line3].filter(Boolean).join(", ");
}
